import { z } from 'zod';
import { SanityDocumentSchema, SanityFileObjectSchema } from '../sanity';
import { EntityType } from '../../types';
import { LinkFieldsSchema } from '../shared';
import { SEOSchema } from '../shared/SEO';
import { ImageAssetSchema } from '../components';

const BrandConfigItemSchema = z.object({
  key: z.string(),
  link: LinkFieldsSchema,
  image: ImageAssetSchema,
  webMVideo: SanityFileObjectSchema,
  mp4Video: SanityFileObjectSchema,
  regions: z
    .array(z.string())
    .nullish()
    // default to all regions
    .transform((x) => x ?? [])
});

export const LandingPageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.LandingPage),
  statement: z.string().nullish(),
  primaryNav: z.array(LinkFieldsSchema).nullish(),
  brandConfig: z.array(BrandConfigItemSchema).nullish(),
  seoAttributes: SEOSchema.nullish()
});

export type BrandConfigItem = z.infer<typeof BrandConfigItemSchema>;
export type LandingPage = z.infer<typeof LandingPageSchema>;
